import { deleteApi, getApi, postApi, putApi } from "../apiCall";

export const handleAddUser_Admin = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/user`;
  return postApi(url, payload);
};

export const handleUpdateUser_Admin = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/user`;
  return putApi(url, payload);
};

export const handleUpdateCompanyStatus_Admin = ({ companyId, status }) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/${companyId}/updateCompanyStatus?status=${status}`;
  return putApi(url);
};

export const handleDisableUser_Admin = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/user/${id}`;
  return deleteApi(url);
};

export const adminCompanyAccess = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/companies/assign-admin`;
  return postApi(url, payload);
};

export const adminCompanyReassignAccess = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/companies/re-assign-admin`;
  return postApi(url, payload);
};

export const addUserSuperAdmin = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/user/create-user`;
  return postApi(url, payload);
};

export const addConsumerSuperAdmin = (payload, companyId) => {
  const url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/consumerDetails/create?companyId=${companyId}`;
  return postApi(url, payload);
};

export const addGeneratorSuperAdmin = (payload, companyId) => {
  const url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/generatorDetails/create?companyId=${companyId}`;
  return postApi(url, payload);
};

export const updateUserSuperAdmin = (payload) => {
  const url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/user/update`;
  return putApi(url, payload);
};

export const updateConsumerSuperAdmin = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/consumerDetails/update`;
  return putApi(url, payload);
};

export const updateGeneratorSuperAdmin = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/generatorDetails/update`;
  return putApi(url, payload);
};

export const changeConsumerActiveStatusSuperAdmin = (
  consumerId,
  status,
  userName
) => {
  const url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/consumerDetails/changeActiveStatus/${consumerId}?status=${status}&userName=${userName}`;
  return deleteApi(url, null, {}, false);
};

export const changeGeneratorActiveStatusSuperAdmin = (
  generatorId,
  status,
  userName
) => {
  const url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/generatorDetails/changeActiveStatus/${generatorId}?status=${status}&userName=${userName}`;
  return deleteApi(url, null, {}, false);
};

export const changeUserActiveStatusSuperAdmin = (
  userId,
  status,
  requesterUserId
) => {
  const url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/user/changeActiveStatus/${userId}?status=${status}&requesterUserId=${requesterUserId}`;
  return deleteApi(url, null, {}, false);
};

export const apiAssignCompanyTrader = ({
  companyId,
  traderUserId,
  consumerId,
  generatorId,
}) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/assignTraderUser?traderUserId=${traderUserId}&companyId=${companyId}`;
  if (consumerId != null) url += `&consumerId=${consumerId}`;
  if (generatorId != null) url += `&generatorId=${generatorId}`;
  return postApi(url);
};

export const UnassignCompanyTrader = ({
  companyId,
  traderUserId,
  consumerId,
  generatorId,
}) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/unassigned-traders/to-entity?traderUserId=${traderUserId}&companyId=${companyId}`;
  if (consumerId != null) url += `&consumerId=${consumerId}`;
  if (generatorId != null) url += `&generatorId=${generatorId}`;
  return deleteApi(url);
};

export const getAssignedCompanyTraders = ({
  companyId,
  consumerId,
  generatorId,
}) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/assigned-trader/by-entity?companyId=${companyId}`;
  if (consumerId != null) url += `&consumerId=${consumerId}`;
  if (generatorId != null) url += `&generatorId=${generatorId}`;
  return getApi(url);
};

export const downloadListingSuperAdmin = ({ id, companyId, userId }) => {
  const url = `${process.env.REACT_APP_API_URL}/doc/super-admin/generate/listing/PDF/BSB/${id}?companyId=${companyId}&userId=${userId}`;
  return postApi(url, {}, {}, false, "blob");
};

export const downloadBankingSuperAdmin = ({ id, companyId, userId }) => {
  const url = `${process.env.REACT_APP_API_URL}/doc/super-admin/generate/listing/PDF/BANKING/${id}?companyId=${companyId}&userId=${userId}`;
  return postApi(url, {}, {}, false, "blob");
};

export const getDocumentRaSuperAdmin = ({ id, companyId, userId }) => {
  let url = `${process.env.REACT_APP_API_URL}/doc/super-admin/generate/listing/PDF/BSRA/${id}?companyId=${companyId}&userId=${userId}`;
  return postApi(url, {}, {}, false, "blob");
};
